import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/Modal'
import StripeKPIs from '@ublique/components/Template/components/StripeKPIs'
import StripeTables from '@ublique/components/Template/components/StripeTables'
import useDetailTableConfig from '../hooks/useDetailTableConfig'
import useDetailKpisConfig from '../hooks/useDetailKpisConfig'

import '../index.scss'

const StatusDetailModal = ({
  open,
  close,
  data: { onRefreshData, selectedRow, tH }
}) => {
  const { t } = useTranslation('Common')
  const [key, setKey] = useState('')

  const kpisConfig = useDetailKpisConfig({ key })
  const tablesConfig = useDetailTableConfig({ selectedRow, setKey })
  const [cData] = useState(selectedRow)

  const config = [
    { key: 'enteStanzaLabel', title: tH('ENTE_STANZA') },
    { key: 'category', title: tH(`CATEGORY`) },
    { key: 'season', title: tH(`SEASON`) },
    { key: 'apc', title: tH(`APC`) },
    { key: 'eventoLabel', title: tH(`EVENT`) }
  ]

  return (
    <Modal
      size='xl'
      open={open}
      onRequestClose={() => {
        onRefreshData()
        close()
      }}
      passiveModal
      preventCloseOnClickOutside
      modalHeading={t('ExtraOutput:UserFeedback.COMPOSITION_DETAIL')}
      className='composition-detail-modal'
    >
      <div className='info-bar'>
        {config.map((item) => (
          <span key={item.key}>
            <strong>{item.title}:</strong> {cData[item.key]}
          </span>
        ))}
      </div>
      <StripeTables tables={tablesConfig} />
      <StripeKPIs kpis={kpisConfig} />
    </Modal>
  )
}

export default StatusDetailModal
